
import { defineComponent } from "vue"
import MatchGameRecordsDetail from "@/components/match_game_records/Detail.vue"

export default defineComponent({
  components: {
    MatchGameRecordsDetail
  }
})
